module.exports = __webpack_public_path__ + "img/beeline.db1e521d.png";